import { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useQuery } from '@apollo/client'
import { DateTime } from 'luxon'
import { GET_PAST_GROUP_EVENTS, GET_UPCOMING_GROUP_EVENTS } from './query'
import { GROUP_EVENT_PAGE_LIMIT } from 'lib/pga-dot-coach'

const useGroupEventsQuery = (query, variables, skip) => {
  return useQuery(query, {
    variables,
    skip,
  })
}

const useGroupEventsPanel = ({ skip = false } = {}) => {
  const history = useHistory()
  const [selectedTab, setSelectedTab] = useState('upcoming')
  const [showCanceledEvents, setShowCanceledEvents] = useState(false)
  const [offset, setOffset] = useState(0)
  const [showLimitReachedDisclaimer, setShowLimitReachedDisclaimer] = useState(
    false,
  )
  const [openFreeTierLimitDialog, setOpenFreeTierLimitDialog] = useState(false)
  const [isPgaHopeCoach, setIsPgaHopeCoach] = useState(false)

  useEffect(() => {
    setOffset(0)
  }, [selectedTab, showCanceledEvents])

  const showPastEvents = selectedTab === 'past'
  const startDateTime = showPastEvents
    ? {
      from: null,
      to: DateTime.local()
        .startOf('day')
        .toISO(),
    }
    : {
      from: DateTime.now()
        .startOf('day')
        .toISO(),
      to: null,
    }

  const pastEventsVariables = {
    orderBy: { field: 'START_DATE_TIME', direction: 'DESC' },
    startDateTime,
    includeCanceled: showCanceledEvents,
    limit: GROUP_EVENT_PAGE_LIMIT,
    offset,
    skip: selectedTab !== 'past',
  }

  const upcomingEventsVariables = {
    orderBy: { field: 'START_DATE_TIME', direction: 'ASC' },
    startDateTime,
    includeCanceled: showCanceledEvents,
    limit: GROUP_EVENT_PAGE_LIMIT,
    offset,
    skip: selectedTab === 'past',
  }

  const pastEventsResult = useGroupEventsQuery(
    GET_PAST_GROUP_EVENTS,
    pastEventsVariables,
    skip || selectedTab !== 'past',
  )
  const upcomingEventsResult = useGroupEventsQuery(
    GET_UPCOMING_GROUP_EVENTS,
    upcomingEventsVariables,
    skip || selectedTab === 'past',
  )

  const queryResult =
    selectedTab === 'past' ? pastEventsResult : upcomingEventsResult
  const { data, loading, error, refetch } = queryResult

  const handleCreateEventClick = () => {
    if (showLimitReachedDisclaimer) {
      setOpenFreeTierLimitDialog(true)
      return
    }
    history.push('/pga-coach/bookings/events/new')
  }

  return {
    selectedTab,
    setSelectedTab,
    showCanceledEvents,
    setShowCanceledEvents,
    offset,
    setOffset,
    showLimitReachedDisclaimer,
    setShowLimitReachedDisclaimer,
    openFreeTierLimitDialog,
    setOpenFreeTierLimitDialog,
    isPgaHopeCoach,
    setIsPgaHopeCoach,
    data,
    loading,
    error,
    refetch,
    handleCreateEventClick,
  }
}

export default useGroupEventsPanel
